import { Observable } from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndpointService } from '@app/core';
import { EtapaBase } from '@app/shared';

@Injectable()
export class StagesTimeControlDataService {

  constructor(private http: HttpClient, private toastr: ToastrService,private api: EndpointService) { }

  /**
   * Agrega una etapa al sistema
   *
   * @param {EtapaBase} stage
   * @return {*}  {Promise<boolean>}
   * @memberof StagestimecontrolDataService
   */
  addStage(stage: EtapaBase): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().post<boolean>(this.api.get('adminStages'), stage).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Etapa agregada correctamente');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }


  /**
   * actualiza una etapa en el sistema
   *
   * @param {number} id
   * @param {EtapaBase} stage
   * @return {*}  {Promise<boolean>}
   * @memberof StagestimecontrolDataService
   */
  updateStage(id: number, stage: EtapaBase): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().put<boolean>(this.api.get('adminStages', [id]), stage).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Etapa modificada correctamente');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }

  
  /**
   * Elimina una etapa del sistema
   *
   * @param {number} id
   * @return {*}  {Promise<boolean>}
   * @memberof StagesTimeControlDataService
   */
  deleteStage(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().delete<boolean>(this.api.get('adminStages', [id])).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Etapa eliminado correctamente');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-automation/time-control/stages-time-control/shared/stages-time-control.data.service.ts